import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    List,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    ListItem,
    TextField
} from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { connect } from 'react-redux';
import DialogCloseButton from '../buttons/DialogCloseButton';
import CircleProgressButton from '../buttons/CircleProgressButton';
import { exportsActions } from '../pages/ExportsPage/store';

const styles = theme => ({
    dialogPaper: {
        width: 350
    },
    ytInputListItem: {
        paddingLeft: 0,
        paddingRight: 0
    }
});

class YouTubeUploadDialog extends React.Component {
    state = {
        title: '',
        description: '',
        tags: '',
        category: '10',
        privacy: 'public'
    }

    render() {
        const { 
            classes, open, closeYouTubeUploadDialog, isUploadingToYouTube, changeYouTubeChannel
        } = this.props;
        
        const { 
            title, description, tags, privacy, category 
        } = this.state;

        return (
            <Dialog
                open={open}
                onClose={closeYouTubeUploadDialog}
                aria-labelledby='youtube-upload-dialog-title'
                PaperProps={{
                    className: classes.dialogPaper
                }}
            >
                <DialogTitle id='youtube-upload-dialog-title'>
                    YouTube Upload Settings
                    <DialogCloseButton
                        onClick={closeYouTubeUploadDialog}
                    />
                </DialogTitle>
                <DialogContent>
                    <List>
                        <ListItem className={classes.ytInputListItem}>
                            <TextField
                                variant="standard"
                                fullWidth
                                label={'Title'}
                                value={title}
                                onChange={this.setTitle}
                                disabled={isUploadingToYouTube} />
                        </ListItem>
                        <ListItem className={classes.ytInputListItem}>
                            <TextField
                                variant="standard"
                                fullWidth
                                label={'Description'}
                                value={description}
                                onChange={this.setDescription}
                                disabled={isUploadingToYouTube}
                                multiline />
                        </ListItem>
                        <ListItem className={classes.ytInputListItem}>
                            <TextField
                                variant="standard"
                                fullWidth
                                label={'Tags (separate with ,)'}
                                value={tags}
                                onChange={this.setTags}
                                disabled={isUploadingToYouTube} />
                        </ListItem>
                        <ListItem className={classes.ytInputListItem}>
                            <FormControl variant="standard" fullWidth>
                                <InputLabel id='category-select-label'>Category</InputLabel>
                                <Select
                                    variant="standard"
                                    labelId='category-select-label'
                                    label='Category'
                                    value={category}
                                    onChange={this.setCategory}
                                    fullWidth
                                    disabled={isUploadingToYouTube}>
                                    {youTubeCategories.map((category) => 
                                        <MenuItem 
                                            value={category.id} 
                                            dense
                                            key={category.id}
                                        >{category.title}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </ListItem>
                        <ListItem className={classes.ytInputListItem}>
                            <FormControl variant="standard" fullWidth> 
                                <InputLabel id='privacy-select-label'>Privacy Status</InputLabel>
                                <Select
                                    variant="standard"
                                    labelId='privacy-select-label'
                                    label='Privacy Status'
                                    value={privacy}
                                    onChange={this.setPrivacy}
                                    fullWidth
                                    disabled={isUploadingToYouTube}>
                                    <MenuItem 
                                        value={'public'} 
                                        dense
                                    >Public</MenuItem>
                                    <MenuItem 
                                        value={'unlisted'} 
                                        dense
                                    >Unlisted</MenuItem>
                                    <MenuItem 
                                        value={'private'} 
                                        dense
                                    >Private</MenuItem>
                                </Select>
                            </FormControl>
                        </ListItem>
                    </List>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'space-between' }}>
                    <CircleProgressButton
                        loading={isUploadingToYouTube}
                        onClick={changeYouTubeChannel}
                    >
                        Change Channel
                    </CircleProgressButton>
                    <CircleProgressButton
                        variant='outlined'
                        color='primary'
                        loading={isUploadingToYouTube}
                        onClick={this.submit}
                    >
                        Upload Video
                    </CircleProgressButton>
                </DialogActions>
            </Dialog>
        );
    }

    setTitle = (event) => {
        this.setState({ title: event.target.value })
    }
    setDescription = (event) => {
        this.setState({ description: event.target.value })
    }
    setTags = (event) => {
        this.setState({ tags: event.target.value })
    }
    setCategory = (event) => {
        this.setState({ category: event.target.value })
    }
    setPrivacy = (event) => {
        this.setState({ privacy: event.target.value })
    }

    submit = () => {
        const { exportId, uploadExportToYouTube } = this.props;

        uploadExportToYouTube(exportId, this.state);
    }
}

const mapStateToProps = (state) => {
    const {
        isUploadingToYouTube
    } = state.exports

    return {
        isUploadingToYouTube
    }
}

const mapDispatchToProps = (dispatch) => {
    const uploadExportToYouTube = (exportId, settings) => dispatch(exportsActions.uploadExportToYouTube(exportId, settings));
    const closeYouTubeUploadDialog = (exportId, settings) => dispatch(exportsActions.closeYouTubeUploadDialog());
    const changeYouTubeChannel = () => dispatch(exportsActions.changeYouTubeChannel());

    return {
        uploadExportToYouTube,
        closeYouTubeUploadDialog,
        changeYouTubeChannel
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(YouTubeUploadDialog, styles));

const youTubeCategories = [
    {
        title: 'Music',
        id: '10'
    },
    {
        title: 'Film & Animation',
        id: '1'
    },
    {
        title: 'Autos & Vehicles',
        id: '2'
    },
    {
        title: 'Pets & Animals',
        id: '15'
    },
    {
        title: 'Sports',
        id: '17'
    },
    {
        title: 'Travel & Events',
        id: '19'
    },
    {
        title: 'Gaming',
        id: '20'
    },
    {
        title: 'People & Blogs',
        id: '22'
    },
    {
        title: 'Comedy',
        id: '23'
    },
    {
        title: 'Entertainment',
        id: '24'
    },
    {
        title: 'News & Politics',
        id: '25'
    },
    {
        title: 'Howto & Style',
        id: '26'
    },
    {
        title: 'Education',
        id: '27'
    },
    {
        title: 'Science & Technology',
        id: '28'
    },
    {
        title: 'Nonprofits & Activism',
        id: '29'
    }
]